import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=207eda2c&scoped=true"
import script from "./OrderSearch.vue?vue&type=script&lang=js"
export * from "./OrderSearch.vue?vue&type=script&lang=js"
import style0 from "./OrderSearch.vue?vue&type=style&index=0&id=207eda2c&prod&lang=scss"
import style1 from "./OrderSearch.vue?vue&type=style&index=1&id=207eda2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207eda2c",
  null
  
)

export default component.exports